// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts"
import { actionBlue } from "components/shell/presentation/AppStyles"
import { useAppSelector } from "hooks/redux"
import { DocumentEvaluationStatus } from "networking/reportsApi"
import { useEffect, useMemo, useState } from "react"
import { selectIsReportPublished, selectReportDocumentId, selectReportDocumentsView } from "store/reports/selectors"
import styled from "styled-components"

const getStatusColor = (status: DocumentEvaluationStatus | undefined) => {
    switch (status) {
        default:
            return actionBlue;
    }
}

const NotificationContainer = styled.div<{ hide?: boolean, status?: DocumentEvaluationStatus }>`
    height: 16px;
    margin-left: 25px;
    margin-top:6px;
    margin-bottom: 11px;
    color: ${props => getStatusColor(props.status)};
    font-family: ${dgFontFamily};
    font-size: 14px;
    display: ${props => props.hide ? 'none' : 'flex'};
    width: 100%;
    justify-content: center;
`

export const DocumentStateNotification = () => {
    const [showNotification, setShowNotification] = useState(false);
    const isPublished = useAppSelector(selectIsReportPublished);
    const documentId = useAppSelector(selectReportDocumentId);
    const documentStatus = useAppSelector(state => selectReportDocumentsView(state)?.entities[documentId]?.state.evaluationStatus);

    useEffect(() => {
        setShowNotification(!!isPublished &&
            (documentStatus === DocumentEvaluationStatus.OutOfDate ||
                documentStatus === DocumentEvaluationStatus.Error));
    }, [documentStatus, isPublished])

    const notificationText = useMemo(() => {
        switch (documentStatus) {
            case DocumentEvaluationStatus.OutOfDate:
                return `You've edited this document. When you are done making edits, please republish.`;
            case DocumentEvaluationStatus.Error:
                return 'There\'s been an error. Please republish.';
            default:
                return '';
        }
    }, [documentStatus])

    return (
        <NotificationContainer status={documentStatus} hide={!showNotification}>
            {notificationText}
        </NotificationContainer>)
}

